import angular from 'angular';
import uiRouter from '@uirouter/angularjs';
import newsComponent from './news.component';

const newsModule = angular
  .module('news', [uiRouter])

  .config(($stateProvider) => {
    'ngInject';

    $stateProvider.state('index.news', {
      url: '/news',
      resolve: {
        news: (ApiService) =>
          ApiService.entitySearch({
            q: 'schema:newsPost',
            children: 1,
            sort: '-sort.publishedAt<number>',
            limit: 20,
          }),
      },
      views: {
        content: {
          component: 'news',
        },
      },
    });
  })

  .component('news', newsComponent);

export default newsModule;
